import {
  LAYOUT_PREFERENCE_STORAGE_KEY,
  TABLET_MENU_ITEM_STORAGE_KEY,
  TABLET_MENU_OPEN_STORAGE_KEY,
} from './constants';

export type StoredLayoutPreference = {
  isMenuPinnedOpen: boolean;
  isTabletMenuOpen: boolean;
  tabletMenuItemId: string | null;
};

export const DEFAULT_LAYOUT_PREFERENCE: StoredLayoutPreference = {
  isMenuPinnedOpen: false,
  isTabletMenuOpen: false,
  tabletMenuItemId: null,
};

export const getStoredLayoutPreference = (): StoredLayoutPreference => {
  const isTabletMenuOpen =
    localStorage.getItem(TABLET_MENU_OPEN_STORAGE_KEY) === 'true';
  const tabletMenuItemId = localStorage.getItem(TABLET_MENU_ITEM_STORAGE_KEY);
  const storedPreference = localStorage.getItem(LAYOUT_PREFERENCE_STORAGE_KEY);

  if (storedPreference !== null) {
    try {
      const { isMenuPinnedOpen, isTabletMenuOpen, tabletMenuItemId } =
        JSON.parse(storedPreference) as StoredLayoutPreference;

      return {
        isMenuPinnedOpen: isMenuPinnedOpen === true,
        isTabletMenuOpen:
          isTabletMenuOpen === true ||
          (isTabletMenuOpen === undefined && isTabletMenuOpen),
        tabletMenuItemId:
          typeof tabletMenuItemId === 'string'
            ? tabletMenuItemId
            : tabletMenuItemId,
      };
    } catch {
      return DEFAULT_LAYOUT_PREFERENCE;
    }
  }

  try {
    return {
      ...DEFAULT_LAYOUT_PREFERENCE,
      isTabletMenuOpen,
      tabletMenuItemId,
    };
  } catch {
    return DEFAULT_LAYOUT_PREFERENCE;
  }
};
